import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatToolbarModule } from '@angular/material/toolbar';
import { NSSelectModule } from '@norfolk-southern/accessns-components';

import { CreateNewReportComponent } from '@ruby/modules/report-builder/submodules/create-new-report/components/create-new-report.component';
import { CreateNewReportContainer } from '@ruby/modules/report-builder/submodules/create-new-report/containers/create-new-report.container';
import { CreateNewReportRoutingModule } from '@ruby/modules/report-builder/submodules/create-new-report/create-new-report.routing.module';

@NgModule({
  declarations: [
    CreateNewReportComponent,
    CreateNewReportContainer
  ],
  imports: [
    CommonModule,
    CreateNewReportRoutingModule,
    MatFormFieldModule,
    MatOptionModule,
    MatToolbarModule,
    NSSelectModule,
    ReactiveFormsModule
  ],
  exports: [CreateNewReportContainer]
})
export class CreateNewReportModule {}
